var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalCalls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.942,
    height: 12.944,
    viewBox: "0 0 12.942 12.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9c9fa3",
    d: "M12.224,29.26a8.1,8.1,0,0,1-2.568-.411.739.739,0,0,0-.732.175L7.7,30.074a10.44,10.44,0,0,1-4.739-4.56l1.227-1.236a.693.693,0,0,0,.181-.72,8.178,8.178,0,0,1-.41-2.566.721.721,0,0,0-.719-.72H.719a.721.721,0,0,0-.719.72A12.222,12.222,0,0,0,12.224,33.216a.72.72,0,0,0,.718-.719V29.981A.721.721,0,0,0,12.224,29.26Z",
    transform: "translate(0 -20.272)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCalls);
export default __webpack_public_path__ + "static/media/totalCalls.d36ef4dd.svg";
export { ForwardRef as ReactComponent };